import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/manipulation/remove/remove.js";
import "dabbyjs/src/manipulation/html/html.js";
import "dabbyjs/src/utils/each/each.js";

export default (data, template) => {
	const nodes = $("<div>").html(template);

	// remove nodes where there is no value
	$("[template-include]", nodes).each(function () {
		const $this = $(this),
			key = $this.attr("template-include");
		if (typeof data[key] === "undefined" || data[key] === null) {
			$this.remove();
		} else {
			$this.attr("template-include", null);
		}
	});

	// insert data
	$("[template-key]", nodes).each(function () {
		const $this = $(this),
			key = $this.attr("template-key");
		if (typeof data[key] === "undefined" || data[key] === null) {
			$this.remove();
		} else {
			$this.text(data[key]);
			$this.attr("template-key", null);
		}
	});

	// process attributes
	$("[template-attr]", nodes).each(function () {
		const $this = $(this),
			attr = {};
		$.each(JSON.parse($this.attr("template-attr")), (key, value) => {
			attr[key] = data[value];
		});
		$this.attr(attr);
		$this.attr("template-attr", null);
	});

	// compile HTML
	return nodes.html();
};
